<fullscreen-page>
  <content-column>
    <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden" slot="content">
      <div class="d-flex flex-column np-header">
        <div class="p-2 h2">
          {{ containerTitle | translate }}
        </div>

        <div class="d-flex flex-row p-2 align-items-center gap-2">
          <dx-button
            (onClick)="openCreateCatalogsPopup()"
            stylingMode="outlined"
            text="{{ 'Neue Kataloge hinzufügen' | translate }}"
            type="default"
          >
          </dx-button>

          <dx-text-box
            (onValueChanged)="onSearchChanged($event)"
            [(value)]="containerSearchText"
            [showClearButton]="true"
            mode="search"
          >
          </dx-text-box>

          <dx-button
            (onClick)="startTransportCatalogFromImportToPreparationStageJob()"
            stylingMode="outlined"
            text="{{ 'Transfer in Preparation Stage' | translate }}"
            type="default"
          >
          </dx-button>
        </div>
      </div>

      <np-container-import
        *ngIf="isImportPopupVisible"
        [(visible)]="isImportPopupVisible"
        [containerId]="container?.id"
        [lastCatalogName]="lastCatalogName"
        (importCompleted)="onImportCompleted()"
      >
      </np-container-import>

      <div class="d-flex flex-row flex-grow-1">
        <div class="flex-grow-1 h-100 overflow-auto p-3">
          <div *ngIf="isLoading" class="p-3 text-muted">
            {{ 'Lade Katalog-Container...' | translate }}
          </div>
          <div *ngIf="!isLoading && !container" class="p-3 text-danger">
            {{ 'Katalog-Container nicht gefunden.' | translate }}
          </div>

          <dx-tab-panel
            *ngIf="!isLoading && container"
            [animationEnabled]="true"
            [swipeEnabled]="false"
            iconPosition="start"
            stylingMode="primary"
            width="100%"
          >
            <dxi-item [title]="'Kataloge' | translate" icon="floppy">
              <div *dxTemplate>
                <np-catalog-tab
                  [container]="container"
                  (inspectCatalog)="onInspectCatalogRequested($event)"
                >
                </np-catalog-tab>
              </div>
            </dxi-item>

            <dxi-item [title]="'Mappings' | translate" icon="comment">
              <div *dxTemplate>
                <dx-tab-panel>
                  <dxi-item [title]="'Hersteller' | translate">
                    <np-manufacture-mapping-tab
                      [container]="container">
                    </np-manufacture-mapping-tab>
                  </dxi-item>
                  <dxi-item [title]="'Kategorien' | translate">
                    <np-category-mapping-tab
                      [container]="container"
                    ></np-category-mapping-tab>
                  </dxi-item>
                  <dxi-item [title]="'Einheitenmapping' | translate">
                    <np-unit-mapping-tab
                      [container]="container">
                    </np-unit-mapping-tab>
                  </dxi-item>
                </dx-tab-panel>
              </div>
            </dxi-item>

            <dxi-item [title]="'Workflow' | translate">
              <div *dxTemplate>
                <np-dataprocess-workflow></np-dataprocess-workflow>
              </div>
            </dxi-item>
          </dx-tab-panel>
        </div>

        <np-inspect-panel
          (containerSaved)="onContainerSaved($event)"
          [container]="container"
          [context]="inspectContext"
          [catalogId]="selectedCatalogId">
        </np-inspect-panel>

      </div>
    </div>
  </content-column>
</fullscreen-page>
